import { InjectedFormProps } from "redux-form";
import { Field } from "redux-form/immutable";

import { Box, Button, Link, Stack, Text } from "@seneca/senekit";

import { linkToHealthResourcesArticle } from "common/links";

import { useSelector } from "seneca-common/utils/hooks/selectors";

import FormArea from "features/common/forms/components/FormArea";
import FormCheckboxGroup from "features/common/forms/components/FormCheckboxGroup";
import SubmitCounterPulseWrapper from "features/common/forms/components/SubmitCounterPulseWrapper";
import { isMobile } from "features/common/utils/functions/mobile";
import { getHelpLinkRegionCode } from "features/regions/selectors";

type Props = {
  feedbackTypes?: string[];
  feedbackPlaceholder?: string;
  showWellbeingMessage?: boolean;
  pulse: boolean;
  incrementSubmitCount: () => void;
} & InjectedFormProps;

export default SubmitCounterPulseWrapper(FeedbackForm);

function FeedbackForm({
  handleSubmit,
  submitting,
  error,
  feedbackPlaceholder = "Any other info...",
  showWellbeingMessage,
  feedbackTypes,
  pulse,
  incrementSubmitCount
}: Props) {
  const locale = useSelector(getHelpLinkRegionCode);

  const onSubmit = () => {
    incrementSubmitCount();
    // @ts-ignore
    handleSubmit();
  };

  return (
    <Stack align="center" space="xlarge">
      {feedbackTypes && feedbackTypes.length > 0 && (
        <Field
          name="feedbackType"
          component={FormCheckboxGroup}
          options={feedbackTypes}
          pulse={pulse}
          hideError
        />
      )}
      <Box width="100%" minHeight="100px" marginBottom="large">
        <Field
          placeHolder={feedbackPlaceholder}
          name="feedback"
          component={FormArea}
          pulse={pulse}
          autoFocus={!isMobile()}
        />
      </Box>
      {showWellbeingMessage && (
        <Text size="small">
          If you have been affected by any of the issues raised in this course
          please{" "}
          <Link to={linkToHealthResourcesArticle(locale)} newTab>
            click here
          </Link>
          .
        </Text>
      )}
      <Button onClick={onSubmit} loading={submitting} tone="primary">
        Submit
      </Button>
    </Stack>
  );
}
